import type {
  ClickableLabeledImageItem,
  SuggestionButtonPopover,
} from '@/scenes/Editor/components/EditWithAI/components/suggestedButtonSets'

type ModelGridPopoverParams = {
  title: string
  aspectRatio?: number | string
  items: ClickableLabeledImageItem[]
}

export function createModelGridPopover({
  title,
  aspectRatio,
  items,
}: ModelGridPopoverParams): SuggestionButtonPopover {
  return {
    designType: 'grid',
    title,
    width: 320,
    height: 400,
    columns: 3,
    aspectRatio: aspectRatio ?? '2/3',
    items,
  }
}
